module.exports = __webpack_public_path__ + "img/Ranking-banner2@2x.4def9673.png";